import { Box, Tag } from "@chakra-ui/react";
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from "react-icons/md";

type StatusTag = {
  isFilled: any;
};

export default function BulletIcon({ isFilled }: StatusTag) {

  return (
    <Tag colorScheme={ isFilled ? "green" : "red"} minHeight={"100%"} fontSize={"small"}>
      {
        isFilled ? "Completato" : "Non completato"
      }
    </Tag>
  );
}
